module.exports = __webpack_public_path__ + "img/HiTeach5_logo.5677b92e.png";